import { createValueStorage } from '@bos/utils';
import { z } from 'zod';
const locales = ['cs', 'en'];
const localeSchema = z.object({
    selectedLocale: z.enum(locales),
});
export const localeStorage = createValueStorage('selectedLocale', localeSchema);
